import type { MovementError } from "@features/vessel-call/vessel-call-status/MovementServices/form/utils.ts";
import { deleteResource as deleteResourceService } from "@services/movementServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useDeleteResource = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: MovementError) => void;
}) => {
  const deleteResourceMutation = useMutation({
    mutationFn: (variables: Parameters<typeof deleteResourceService>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "MovementService",
          action: "delete_resource",
          entityType: "movement_service",
        },
        (transactionId) =>
          deleteResourceService({
            ...variables,
            ...(transactionId ? { transactionId } : {}),
          }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: MovementError) => handleError(error),
  });

  const deleteResource = async (variables: Parameters<typeof deleteResourceService>[0]) => {
    deleteResourceMutation.mutate(variables);
  };

  return {
    deleteResource,
  };
};
